import { Component, OnInit, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MapsSidebarService } from '../../maps-sidebar.service';

@Component({
  selector: 'app-demographic-filter',
  templateUrl: './demographic-filter.component.html',
  styleUrls: ['./demographic-filter.component.less'],
})
export class DemographicFilterComponent implements OnInit {

  isDemographicsOn: boolean = true;
  demographicFilterActiveSubscription: Subscription;
  closeOnClickRef: any;

  ringsAddedSubscription: any;
  polygonAddedSubscription: any;
  driveTimeAddedSubscription: any;
  demographicFiltersChangedSubscription: any;
  currentUser: any;
  getCurrentUserSubscription: any;
  trafficLayerChangedSubscription: any;

  constructor(public elementRef: ElementRef, public mapsSidebarService: MapsSidebarService) { }

  ngOnInit() {
    this.closeOnClickRef = this.closeOnOutsideClick.bind(this);
    this.demographicFilterActiveSubscription = this.mapsSidebarService.demographicFilterActiveStream.subscribe((value)=> {
      if(value) {
        document.addEventListener('click', this.closeOnClickRef, true);
      }
    });
  }

  ngAfterViewInit() {
    let w = (<any>window);
    this.ringsAddedSubscription = w.Events.subscribe('ringsAdded',(toggle)=>{
      w.setMapDataProperty('showRings', toggle);
      let ringsInput = <HTMLInputElement>document.getElementById('demographic-rings-input');
      if(ringsInput) {
        ringsInput.checked = toggle;
      }
      this.toggleDemographics(toggle);
    });

    this.polygonAddedSubscription = w.Events.subscribe('polygonAdded',(toggle)=>{
      w.setMapDataProperty('showPolygons', toggle);
      this.toggleDemographics(toggle);
    });

    this.driveTimeAddedSubscription = w.Events.subscribe('driveTimeAdded',(toggle)=>{
      w.setMapDataProperty('showDriveTime', toggle);
      let drivetimesInput = <HTMLInputElement>document.getElementById('demographic-drivetimes-input');
      if(drivetimesInput) {
        drivetimesInput.checked = toggle;
      }
      this.toggleDemographics(toggle);
    });

    this.demographicFiltersChangedSubscription = w.Events.subscribe('demographicFiltersChanged', ()=>{
      this.isDemographicsOn = w.mapData.demographicFilterActive;
      w.rings.toggleRingsClass(w.mapData.demographicFilterActive && w.mapData.showRings);
      w.driveTime.toggleDriveTimeClass(w.mapData.demographicFilterActive && w.mapData.showDriveTime);
      (<any>window).Events.publish('detectChanges');
    });

    this.trafficLayerChangedSubscription = w.Events.subscribe('trafficLayerChanged', (data)=>{
      if(data && data.toggle) {
        this.toggleDemographics(false);
      }
    });
    
    this.getCurrentUserSubscription = w.Events.subscribe('getLoggedInUser', (data) => {
      this.currentUser = data;
      w.Events.publish('detectChanges');
    });
  }

  closeOnOutsideClick(event: Event) {
    let w = (<any>window);
    if (event.target !== this.elementRef.nativeElement
      && !this.elementRef.nativeElement.contains(event.target)
      && !w.hasClass(event.target, 'layer-filter-sub-header')
      && !w.hasClass(event.target, 'toggle-layers-holder')
      && !w.hasClass(event.target, 'filter-counter')
      && !w.hasClass(event.target, 'filter-icon')
      && !w.hasClass(event.target, 'arrow-icon')) {
      this.closeDemographicFilter();
      document.removeEventListener('click', this.closeOnClickRef, true);
    }
  }

  closeDemographicFilter() {
    let w = (<any>window);
    this.mapsSidebarService.showDemographicFilter = false;
    w.Events.publish('detectChanges');
    w.localStorageHandler.updateSideBarToLS();
  }

  getPolygonCount() {
    return ((<any>window).polygon.shapes)? ((<any>window).polygon.shapes.length): 0;
  }

  togglePolygons(event) {
    let w = (<any>window);
    w.setMapDataProperty('showPolygons', event.target.checked);
    w.polygon.toggleVisible(event.target.checked);
    w.localStorageHandler.updatePolygonData();
  }

  isPolygonChecked() {
    let w = (<any>window);
    return w.mapData? w.mapData.showPolygons : false;
  }

  getRingsCount() {
    return ((<any>window).rings.getTotalActiveRings())? ((<any>window).rings.getTotalActiveRings()): 0;
  }

  toggleRings(event) {
    let w = (<any>window);
    w.setMapDataProperty('showRings', event.target.checked);
    w.rings.toggleVisible(event.target.checked);
    w.localStorageHandler.updateRingData();
  }

  isRingsChecked() {
    let w = (<any>window);
    return w.mapData? w.mapData.showRings: false;
  }

  getDriveTimeCount() {
    return ((<any>window).driveTime.getTotalActiveDriveTimes())? ((<any>window).driveTime.getTotalActiveDriveTimes()): 0;
  }

  toggleDriveTime(event) {
    let w = (<any>window);
    w.setMapDataProperty('showDriveTime', event.target.checked);
    w.driveTime.toggleVisible(event.target.checked);
    w.localStorageHandler.updateDriveTimeData();
  }

  isDriveTimeChecked() {
    let w = (<any>window);
    return w.mapData? w.mapData.showDriveTime: false;
  }

  addRingsToPoint() {
    let w = (<any>window);
    this.mapsSidebarService.getLoggedInUser().subscribe((userDetails: any) => {
      if(userDetails.userId > 0 && this.mapsSidebarService.isUserLoggedIn()) {
        if(!userDetails.canGetDemographics) {
          w.Events.publish('openContactSupportPopup');
          return;
        }
      } else if(userDetails.hasSavedRing) {
          w.Events.publish('usageLimitErrorFeature','add-ring');
          w.Events.publish('popup', 'sign-up');
          w.Events.publish('updateFeatureExecutionAfterSignUp',{
            featureToExecute : 'add-ring-drawing-mode',
            requestObject : true
          });
        return;
      }

      w.addClass(w.domBody, 'add-stuff');
      w.demographicPoint.startDrawingMode({rings: true});
    });
  }

  addPolygon() {
    let w = (<any>window);
    this.mapsSidebarService.getLoggedInUser().subscribe((userDetails: any) => {
      if(userDetails.userId > 0 && this.mapsSidebarService.isUserLoggedIn()) {
        if(!userDetails.canGetDemographics) {
          w.Events.publish('openContactSupportPopup');
          return;
        }
      } else {
        w.Events.publish('usageLimitErrorFeature','add-polygon');
        w.Events.publish('popup', 'sign-up');
        w.Events.publish('updateFeatureExecutionAfterSignUp',{
          featureToExecute : 'add-polygon',
          requestObject : true
        });
        return;
      }
      w.addClass(w.domBody, 'add-stuff');
      w.polygon.drawPolygon();
    });
  }

  addDriveTimeToPoint() {
    let w = (<any>window);
    this.mapsSidebarService.getLoggedInUser().subscribe((userDetails: any) => {
      if(userDetails.userId > 0 && this.mapsSidebarService.isUserLoggedIn()) {
        if(!userDetails.canGetDemographics) {
          w.Events.publish('openContactSupportPopup');
          return;
        }
      } else {
        if(userDetails.hasSavedDrivetime) {
          w.Events.publish('usageLimitErrorFeature', 'add-drivetime');
          w.Events.publish('popup', 'sign-up');
          w.Events.publish('updateFeatureExecutionAfterSignUp',{featureToExecute : 'add-drivetime-drawing-mode' , requestObject : 'true'});
          return;
        }
      }
      w.addClass(w.domBody, 'add-stuff');
      w.demographicPoint.startDrawingMode({driveTime: true});
    });
  }

  toggleDemographics(event) {
    let w = (<any>window);
    let toggle = event.target? event.target.checked: event;
    this.isDemographicsOn = toggle;
    w.setMapDataProperty('demographicFilterActive', toggle);
    w.driveTime.toggleVisible(toggle && w.mapData.showDriveTime);
    w.rings.toggleVisible(toggle && w.mapData.showRings);
    w.polygon.toggleVisible(toggle && w.mapData.showPolygons);
    toggle && w.mapData.showTrafficCount && w.toggleTraffic(false);
    (<any>window).Events.publish('detectChanges');
    w.localStorageHandler.updateMapDataLocalStorage();
  }

  resetDemographics() {
    let w = (<any>window);
    w.polygon.deleteAll();
    w.rings.deleteAllRings();
    w.driveTime.deleteAllDriveTimes();
    w.demographicPoint.deleteAll();
    document.getElementById('infowindows-container').innerHTML = '';
    w.Events.publish('detectChanges');
  }

  removeSubscriptions() {
    this.ringsAddedSubscription && this.ringsAddedSubscription.unsubscribe();
    this.polygonAddedSubscription && this.polygonAddedSubscription.unsubscribe();
    this.driveTimeAddedSubscription && this.driveTimeAddedSubscription.unsubscribe();
    this.demographicFiltersChangedSubscription && this.demographicFiltersChangedSubscription.unsubscribe();
    this.demographicFilterActiveSubscription && this.demographicFilterActiveSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-sidebar/components/demographic-filter/demographic-filter.component.ts